import {DateRangePicker} from "../shared/components/DateRangePicker";
import {useRef, useState} from "react";
import NotificationService from "../services/NotificationService";
import {importService} from "../services/importService";
import notificationService from "../services/NotificationService";
import {Datepicker} from "@mobiscroll/react";
import {AvailableDatePicker} from "../shared/components/AvailableDatePicker";
import {useForm} from "react-hook-form";
import {exportService} from "../services/exportService";

const ReportsPage: React.FC = () => {
    const fileInputRef = useRef(null);
    const { register, control, setValue, reset, getValues, formState: { dirtyFields, errors } } = useForm();
    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file && file.type === "text/plain") {
            const formData = new FormData();
            formData.append("file", file);
            importService.importARCLogistics(formData).then(r => {
                if(!r) return;
                if(r.succeeded)
                    notificationService.success('Successfully uploaded ARC logistics data')
                else{
                    NotificationService.error("Import from file data has failed");
                    if (r.errorMessages[0])
                        NotificationService.error(r.errorMessages[0]);
                }

            })
        } else {
            NotificationService.error("Please select a valid .txt file.");
        }
        event.target.value = "";
    };

    async function ExportARCLogistics() {
        const all = getValues()
        const arcDate = all.arcLogisticsExport;
        if (!arcDate) {
            notificationService.error('Must select a date for ARC Logistics')
            return;
        }
        await exportService.exportArcLogistics(arcDate)
    }
    
    async function ExportCustomerInvoice() {
        const all = getValues()
        if (!all.customerInvoice) {
            notificationService.error('Must select a start and end date range for customer invoices')
            return;
        }
        const startDate = all.customerInvoice[0];
        const endDate = all.customerInvoice[1];
        if (!startDate || !endDate) {
            notificationService.error('Must select a start and end date range for customer invoices')
            return;
        }
        await exportService.exportCustomerInvoices(startDate.toISOString().split('T')[0], endDate.toISOString().split('T')[0])
    }

    return (
        <>
            <div className="container-fluid pt-160">
                <div className="row gx-5 m-2" style={{height: "500px"}}>
                    <div className="col-6 my-2">
                        <div className="card shadow-sm rounded-lg">
                            <div
                                className="card-header d-flex justify-content-between bg-transparent p-3 border-bottom">
                                <h3 className="mb-0"><i className="fa-regular fa-truck-fast opacity-25 me-1"></i> ARC Logistics</h3>
                            </div>
                            <div className="card-body p-4 space-y-4">
                                <p>Import and Export reports for ARC Logistics. The date is only for export.</p>
                                <AvailableDatePicker name={'arcLogisticsExport'} control={control} errors={errors}/>
                                <div className="d-flex gap-3">
                                    <button
                                        onClick={() => fileInputRef.current.click()}
                                        className="btn btn-primary px-5"
                                    >
                                        <i className="fa-regular fa-file-arrow-up"></i> Import
                                    </button>
                                    <input
                                        type="file"
                                        accept=".txt"
                                        ref={fileInputRef}
                                        onChange={handleFileChange}
                                        style={{display: "none"}}
                                    />
                                    <button
                                        className="btn btn-primary px-5"
                                        onClick={() => ExportARCLogistics()}
                                    >
                                        <i className="fa-regular fa-file-arrow-down"></i> Export
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-6 my-2">
                        <div className="card shadow-sm rounded-lg">
                            <div
                                className="card-header d-flex justify-content-between bg-transparent p-3 border-bottom">
                                <h3 className="mb-0"><i className="fa-regular fa-file-invoice opacity-25 me-1"></i> Customer
                                    Invoices</h3>
                            </div>
                            <div className="card-body p-4">
                                <p>Customer Invoice Export. A single date or a date range may be selected</p>
                                <DateRangePicker name={'customerInvoice'} control={control} errors={errors}/>
                                <button className="btn btn-primary px-5" onClick={ExportCustomerInvoice}><i
                                    className="fa-regular fa-file-arrow-down"></i> Export
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>)
}

export default ReportsPage